import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { BottomSheet, Button } from '@doxyme/ui';
import './ConfirmationPopup.scss';
const ANIMATION_DELAY = 300;
export var Theme;
(function (Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})(Theme || (Theme = {}));
export const ConfirmationPopup = ({ isOpen, onCancel, onConfirm, hasOverlay = true, hasCloseBtn = true, theme = Theme.Dark, className, localizationIds: { title: titleId, confirm: confirmId, cancel: cancelId = 'common.cancel', }, children, }) => {
    const intl = useIntl();
    const handleCancel = useCallback(() => onCancel(), [onCancel]);
    const handleConfirm = useCallback(() => onConfirm(), [onConfirm]);
    const [shouldRender, setShouldRender] = useState(isOpen);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShouldRender(isOpen);
        }, isOpen ? 0 : ANIMATION_DELAY);
        return () => clearTimeout(timer);
    }, [isOpen]);
    if (!shouldRender) {
        return null;
    }
    return (<BottomSheet className={classNames('confirmation-popup', className)} isOpen={isOpen} hasOverlay={hasOverlay} hasCloseBtn={hasCloseBtn} onClose={handleCancel} theme={theme}>
      <h4 className="confirmation-popup__title">
        {intl.formatMessage({ id: titleId })}
      </h4>

      {children}

      <div className="confirmation-popup__actions">
        <Button className="confirmation-popup__action confirmation-popup__action--cancel" onClick={handleCancel} pill={true} size="medium" btnStyle="outline" color="reversed">
          {intl.formatMessage({ id: cancelId })}
        </Button>

        <Button className="confirmation-popup__action confirmation-popup__action--confirm" onClick={handleConfirm} pill={true} size="medium" btnStyle="solid" color="error">
          {intl.formatMessage({ id: confirmId })}
        </Button>
      </div>
    </BottomSheet>);
};
